import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { ENV } from "@/config/env";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분
      gcTime: 1000 * 60 * 10, // 10분
      retry: (failureCount, error: any) => {
        if (error?.status === 401 || error?.status === 403) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

// 로컬 스토리지 퍼시스터 설정
export const customPersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: "chewing-admin-query-cache",
  serialize: (data) => JSON.stringify(data),
  deserialize: (data) => JSON.parse(data),
});
